$(document).ready(() => { 
  const basData = Object.values(localStorageKeys.BAS).map((el) => localStorage.getItem(el))
  const basSteps = ['bundle', 'color', 'label', 'finalize']
  const hasSavedBaSData = basData.some(el => !!el);

  new Swiper ('[bas-landing-swiper]', {
    observer: true,
    slidesPerView: 1.55,
    spaceBetween: 18,
    slidesOffsetAfter: 32,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  });

  $('.build-a-system-landing_social_mobile .build-a-system-landing_social_content').eq(0).addClass('active')
  $('.build-a-system-landing_social_mobile .build-a-system-landing_social_header__nav').eq(0).addClass('chosen')

  $(".select__item").click(function() {
    const cards = document.querySelectorAll("div.card");
    const select__item = document.querySelectorAll("div.select__item");
    select__item.forEach(item => {
      $(item).removeClass('selected');
    })

    $(this).addClass('selected')
    
    cards.forEach(card => {
      $(card).removeClass('active');

      if ($(this).text() === card.id) {
        $(card).addClass('active');
      }
    });
  })

  $('.build-a-system-landing_social_header__nav').click(function() {
    $('.build-a-system-landing_social_header__nav').removeClass('chosen')
    $(this).addClass('chosen')
    $('.build-a-system-landing_social_content').removeClass('active')
    $('.build-a-system-landing_social_dop-content').removeClass('active')
    $(`.${this.id}`).addClass('active')
  })

  $('.more_content_show').click(function() {
    $('.more_content_show').removeClass('active')
    $('.build-a-system-landing_social_dop-content').addClass('active')
    $('.more_content_hide').addClass('active')
  })

  $('.more_content_hide').click(function() {
    $('.more_content_hide').removeClass('active')
    $('.build-a-system-landing_social_dop-content').removeClass('active')
    $('.more_content_show').addClass('active')
    $('html, body').animate({
      scrollTop: $("#build-a-system-landing_social_header").offset().top - 250
      }, 300);
  })

  $('.video-link').click(function() {
    $('.overlay, .main-vid-box, .close').fadeIn(500);
    const video = $(this).parent().find('.main-vid-box .modal-videojs-block')
    const curVideo = video.find('video').get(0);
    $(curVideo).attr("controls", true)
    curVideo.play()
  });
  
  $('.close, .overlay').click(function() {
    $('.overlay, .main-vid-box, .close').fadeOut(500);
    const video = $(this).find('.modal-videojs-block')
    const curVideo = video.find('video').get(0);
    curVideo.pause()
  });

  $('.free__link').click(function() {
    $('html').stop().animate({
      'scrollTop': $('.build-a-system-landing_sizes').offset().top
    }, 100, 'linear');
  })
  

  if (!$('html').hasClass('page-build_a_system_landing') && !$('html').hasClass('page-lifeproof')) return

  $(document).on('scroll', function () {
    const showStickyCTA = $(document).scrollTop() > $('.build-a-system-landing_sizes').offset().top
    const $stickyCTA = $('.sticky-bottom-cta')
    const stickyCTAHeight = $stickyCTA.outerHeight()
    $stickyCTA.css({ bottom: showStickyCTA ? 0 : -stickyCTAHeight })
  })

  $('.continue-on-bas-page').toggle(!!hasSavedBaSData).click(() => {
    const index = basData.reverse().findIndex(el => el)
    if (index === -1) return 

    const step = basSteps.reverse()[index]
    const url = `${window.location.origin}/products/build-a-system?&step=${step}`
    window.location.href = url
  })
})

